import template from './sw-cms-block-image-cover.html.twig';
import './sw-cms-block-image-cover.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
